module.exports = __webpack_public_path__ + "static/media/sidebar__profile.9f6da1fa.svg";